import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'unlimitedVacationDays' })
export class UnlimitedVacationDaysPipe implements PipeTransform {
  transform(value: string | null): string | null {
    const year = new Date().getFullYear();
    const days_in_year = new Date(year, 1, 29).getMonth() === 1 ? 366 : 365;
    return value && Number(value) >= days_in_year ? '♾️' : value;
  }
}
